import { gql } from '@apollo/client';

export const CREATE_STUDENT_REQUEST = gql`
  mutation createStudentRequest($data: CreateRequestInput!) {
    createStudentRequest(data: $data) {
      requestId
    }
  }
`;

export const STUDENT_REQUEST_EVIDENCE_UPLOAD_URLS = gql`
  query studentRequestEvicenceUploadURLs($data: StudentRequestUploadURLsInput!) {
    studentRequestUploadURLs(data: $data) {
      id
      url
    }
  }
`;

export const STUDENT_GENERAL_REQUESTS = gql`
  subscription studentGeneralRequests(
    $where: student_general_request_bool_exp
    $order_by: [student_general_request_order_by!]
  ) {
    student_general_request(where: $where, order_by: $order_by) {
      id
      title
      student_request {
        id
        status
        description
        created_at
        student {
          firstName
          lastName
        }
      }
    }
  }
`;

export const STUDENT_MEDICAL_REQUESTS = gql`
  subscription studentMedicalRequests(
    $where: student_medical_request_bool_exp
    $order_by: [student_medical_request_order_by!]
  ) {
    student_medical_request(where: $where, order_by: $order_by) {
      id
      leaveEndDate
      leaveStartDate
      signAndSymptoms
      student_request {
        id
        status
        student {
          firstName
          lastName
        }
      }
    }
  }
`;

export const STUDENT_EXTERNAL_ENGAGEMENT_REQUESTS = gql`
  subscription studentExternalEngagementRequests(
    $where: student_external_engagement_request_bool_exp
    $order_by: [student_external_engagement_request_order_by!]
  ) {
    student_external_engagement_request(where: $where, order_by: $order_by) {
      id
      student_request {
        id
        status
        student {
          firstName
          lastName
        }
      }
      timetable_item {
        batch_subject_configuration {
          subject {
            name
          }
        }
        endTime
        startTime
      }
      student_timetable_item {
        startTime
        endTime
        subjectName
      }
    }
  }
`;

export const STUDENT_GENERAL_REQUEST_FOR_VIEW = gql`
  subscription studentGeneralRequestsForView($where: student_general_request_bool_exp) {
    student_general_request(where: $where) {
      id
      title
      student_request {
        id
        status
        description
        created_at
        approvedOn
        approved_user_public {
          firstName
          lastName
        }
        student_request_requestees {
          id
          user_public {
            firstName
            lastName
            department {
              name
            }
          }
        }
        evidence
        student {
          firstName
          lastName
          regNumber
          sliitID
          student_batch_histories(where: { endDate: { _is_null: true } }) {
            batch_class {
              name
              batch {
                name
                course {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const STUDENT_MEDICAL_REQUEST_FOR_VIEW = gql`
  subscription studentMedicalRequestForView($where: student_medical_request_bool_exp) {
    student_medical_request(where: $where) {
      id
      leaveStartDate
      leaveEndDate
      medicalOfficerName
      signAndSymptoms
      medicalCertificateIssueDate
      student_request {
        id
        status
        description
        created_at
        approvedOn
        approved_user_public {
          firstName
          lastName
        }
        student_request_requestees {
          id
          user_public {
            firstName
            lastName
            department {
              name
            }
          }
        }
        evidence
        student {
          firstName
          lastName
          regNumber
          sliitID
          student_batch_histories(where: { endDate: { _is_null: true } }) {
            batch_class {
              name
              batch {
                name
                course {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const STUDENT_EXTERNAL_ENGAGEMENT_REQUEST_FOR_VIEW = gql`
  subscription studentExternalEngagementRequestForView($where: student_external_engagement_request_bool_exp) {
    student_external_engagement_request(where: $where) {
      id
      timetable_item {
        batch_subject_configuration {
          subject {
            name
          }
        }
        endTime
        startTime
      }
      student_timetable_item {
        startTime
        endTime
        subjectName
      }
      student_request {
        id
        status
        description
        created_at
        approvedOn
        approved_user_public {
          firstName
          lastName
        }
        student_request_requestees {
          id
          user_public {
            firstName
            lastName
            department {
              name
            }
          }
        }
        evidence
        student {
          firstName
          lastName
          regNumber
          sliitID
          student_batch_histories(where: { endDate: { _is_null: true } }) {
            batch_class {
              name
              batch {
                name
                course {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const STUDENT_GENERAL_REQUEST = gql`
  query studentGeneralRequest($where: student_request_bool_exp) {
    student_request(where: $where) {
      description
      evidence
      status
      student_general_requests {
        title
      }
      student_request_requestees {
        userId
      }
    }
  }
`;

export const STUDENT_MEDICAL_REQUEST = gql`
  query studentMedicalRequest($where: student_request_bool_exp) {
    student_request(where: $where) {
      id
      description
      evidence
      status
      student_medical_requests {
        id
        leaveStartDate
        leaveEndDate
        medicalCertificateIssueDate
        medicalOfficerName
        signAndSymptoms
      }
      student_request_requestees {
        userId
      }
    }
  }
`;

export const STUDENT_EXTERNAL_ENGAGEMENT_REQUEST = gql`
  query studentExternalEngagementRequest($where: student_request_bool_exp) {
    student_request(where: $where) {
      description
      evidence
      student_external_engagement_requests {
        student_timetable_item {
          id
          startTime
          endTime
        }
      }
      student_request_requestees {
        userId
      }
    }
  }
`;

export const INSERT_STUDENT_REQUEST_REQUESTEE = gql`
  mutation insertStudentRequestRequestee(
    $objects: [student_request_requestee_insert_input!]!
    $on_conflict: student_request_requestee_on_conflict
  ) {
    insert_student_request_requestee(objects: $objects, on_conflict: $on_conflict) {
      affected_rows
    }
  }
`;

export const UPDATE_STUDENT_REQUEST = gql`
  mutation updateStudentRequest($_set: student_request_set_input, $where: student_request_bool_exp!) {
    update_student_request(_set: $_set, where: $where) {
      affected_rows
    }
  }
`;

export const UPDATE_STUDENT_GENERAL_REQUEST = gql`
  mutation updateStudentGeneralRequest(
    $where: student_general_request_bool_exp!
    $_set: student_general_request_set_input
  ) {
    update_student_general_request(where: $where, _set: $_set) {
      affected_rows
    }
  }
`;

export const UPDATE_STUDENT_MEDICAL_REQUEST = gql`
  mutation updateStudentMedicalRequest(
    $where: student_medical_request_bool_exp!
    $_set: student_medical_request_set_input
  ) {
    update_student_medical_request(where: $where, _set: $_set) {
      affected_rows
    }
  }
`;

export const UPDATE_STUDENT_EXTERNAL_ENGAGEMENT_REQUEST = gql`
  mutation updateStudentExternalEngagementRequest(
    $where: student_external_engagement_request_bool_exp!
    $_set: student_external_engagement_request_set_input
  ) {
    update_student_external_engagement_request(where: $where, _set: $_set) {
      affected_rows
    }
  }
`;

export const DELETE_STUDENT_REQUESTS = gql`
  mutation deleteStudentRequest($where: student_request_bool_exp!) {
    delete_student_request(where: $where) {
      affected_rows
    }
  }
`;

export const UPDATE_STUDENT_REQUEST_STATUS = gql`
  mutation updateStudentRequestStatus(
    $data: UpdateStudentRequestStatusInput!
    $where: UpdateStudentRequestStatusWhereInput!
  ) {
    updateStudentRequestStatus(data: $data, where: $where) {
      affectedRows
    }
  }
`;
